import React from 'react';
import { Navigate } from 'react-router-dom';
import usePermissions from '../hooks/usePermissions';

export function AuthorizedRoute({ moduleKey, children }) {
  const { canRead, loading } = usePermissions();

  if (loading) {
    return (
      <div className="min-h-[calc(100vh-100px)] flex flex-col items-center justify-center">
        <div className="w-12 h-12 border-4 border-[#EBF0FA] border-t-[#3245a4] rounded-full animate-spin"></div>
        <p className="mt-4 text-[#3245a4] font-semibold animate-pulse">Verificando acceso...</p>
      </div>
    );
  }

  // Si no tiene permisos para leer el módulo, lo mandamos al inicio
  // RootRedirect se encargará de enviarlo a su página por defecto
  if (!canRead(moduleKey)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
